var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { fontPretendard } from '../../../fonts';
import { neutralDay } from '@teamsparta/design-system';
import { ButtonWithoutStyle } from '../../../styles/_common.style';
var RequestBtn = function (_a) {
    var isShow = _a.isShow, isActive = _a.isActive, requestFunction = _a.requestFunction, btnText = _a.btnText;
    return (_jsx(_Fragment, { children: isShow && (_jsx(Button, __assign({ isActive: isActive, onMouseDown: function (e) {
                e.preventDefault();
                if (isActive) {
                    requestFunction();
                }
            } }, { children: btnText }))) }));
};
export default RequestBtn;
var Button = styled(ButtonWithoutStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: auto;\n  flex-shrink: 0;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  gap: 10px;\n  height: 36px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 150%;\n  background: ", ";\n  color: ", ";\n  border-radius: 34px;\n  cursor: ", ";\n  position: absolute;\n  right: 20px;\n"], ["\n  display: flex;\n  margin: auto;\n  flex-shrink: 0;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  gap: 10px;\n  height: 36px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 150%;\n  background: ", ";\n  color: ", ";\n  border-radius: 34px;\n  cursor: ", ";\n  position: absolute;\n  right: 20px;\n"])), fontPretendard, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? neutralDay.gray100 : '#1416174d');
}, neutralDay.white, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? 'pointer' : 'default');
});
var templateObject_1;
//# sourceMappingURL=RequestBtn.js.map